export default __webpack_public_path__ + "static/media/line-h-13.fc6ae63a.png";